export default function formatMoneyValue(number?: number | null): string {
  if (!number) {
    return '';
  }

  return number
    ?.toLocaleString('cs-CZ')
    .replace(',', '.');
}
